import MainContainer from "./MainContainer";

const HeaderContainer = ({
  children,
  title,
  header = " ",
  onEdit,
  ...props
}) => {
  return (
    <>
      <h1 className="text-2xl md:text-3xl font-bold md:ml-8">{title}</h1>
      <MainContainer header={header} onEdit={onEdit}>
        {children}
      </MainContainer>
    </>
  );
};

export default HeaderContainer;
